import React, { useEffect } from "react";
import { Box, Stack, Typography, Container, Card, Paper } from "@mui/material";
import "../styles/layout/Header.scss";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container
      className="aboutuspage"
      style={{
        height: "auto",
        maxWidth: "100%",
        padding: "0",
        margin: "0",
        display: "flex",
        flexDirection: "column",
        gap: "2%",
        position: "relative",
      }}
    >
      {/* 'linear-gradient(to bottom, #FFC3EA, #FFFFFF) */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: "#FFEBF8",
          padding: "0 0 10% 0",
        }}
      >
        {/* About Us Title */}
        <Typography
          sx={{
            display: "flex",
            flex: "1",
            fontFamily: "Orbitron",
            fontSize: {
              xs: "36px", // Mobile
              sm: "48px", // Tablet
              md: "60px", // Small Desktop
              lg: "72px", // Large Desktop
            },
            fontWeight: "800",
            color: "#000",
            letterSpacing: "2px",
            justifyContent: "center",
            padding: {
              xs: "6% 5%", // Mobile padding
              md: "4%", // Desktop padding
            },
          }}
        >
          About Us
        </Typography>

        {/* Paragraph 1 */}
        <Typography
          sx={{
            display: "flex",
            fontFamily: "Poppins",
            color: "#585858",
            lineHeight: {
              xs: "28px", // Mobile
              sm: "32px", // Tablet
              md: "42px", // Desktop
            },
            fontWeight: "normal",
            textAlign: "center",
            fontSize: {
              xs: "16px", // Mobile
              sm: "18px", // Tablet
              md: "22px", // Desktop
              lg: "25px", // Large Desktop
            },
            padding: {
              xs: "0 5%", // Mobile padding
              sm: "0 8%", // Tablet padding
              md: "0 10%", // Desktop padding
            },
          }}
        >
          Welcome to Tecloq, where innovation meets intelligence. Founded in
          2018, Tecloq is a leading provider of AI and Data Analytics solutions,
          dedicated to empowering businesses with cutting-edge technologies. Our
          mission is to transform raw data into actionable insights and build
          AI-driven solutions that drive growth, efficiency, and success.
        </Typography>

        {/* Paragraph 2 */}
        <Typography
          sx={{
            display: "flex",
            fontFamily: "Poppins",
            color: "#585858",
            lineHeight: {
              xs: "28px", // Mobile
              sm: "32px", // Tablet
              md: "42px", // Desktop
            },
            fontWeight: "normal",
            textAlign: "center",
            fontSize: {
              xs: "16px", // Mobile
              sm: "18px", // Tablet
              md: "22px", // Desktop
              lg: "25px", // Large Desktop
            },
            padding: {
              xs: "0 5%", // Mobile padding
              sm: "0 8%", // Tablet padding
              md: "0 10%", // Desktop padding
            },
          }}
        >
          With a team of passionate experts, we specialize in delivering
          customized strategies that address complex challenges across
          industries. At Tecloq, we blend technology and creativity to unlock
          the full potential of data and create smarter, data-driven
          enterprises. Join us in shaping the future with AI and analytics.
        </Typography>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          position: "relative",
          backgroundImage:
            'url("/assets/aboutus/peopleofcity.png"), url("/assets/aboutus/citybuildings.png")',
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: {
            xs: "80% auto, cover", // Mobile
            sm: "60% auto, cover", // Tablet
            md: "38% auto, cover", // Desktop
          },
          backgroundPosition: {
            xs: "top left, center", // Mobile
            sm: "left, center", // Tablet
            md: "left, center", // Desktop
          },
          backgroundColor: "#FFEBF8",
          padding: {
            xs: "5% 0 8% 0", // Mobile
            sm: "5% 0 10% 0", // Tablet
            md: "0 0 13% 0", // Desktop
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: {
              xs: "rgba(255, 255, 255, 0.6)", // Dim the background on mobile
              sm: "transparent", // No dimming on larger screens
            },
            zIndex: 0, // Place behind the content
          },
        }}
      >
        {/* Mission Title */}
        <Typography
          sx={{
            position: "relative",
            display: "flex",
            fontFamily: "Orbitron",
            fontSize: {
              xs: "36px", // Mobile
              sm: "48px", // Tablet
              md: "60px", // Desktop
              lg: "72px", // Large Desktop
            },
            fontWeight: "800",
            color: "#000",
            letterSpacing: "2px",
            justifyContent: {
              xs: "center", // Center on mobile
              sm: "end", // Align to right on larger screens
            },
            padding: {
              xs: "4% 5% 0 5%", // Mobile
              sm: "6% 10% 0 0", // Tablet
              md: "8% 10% 0 0", // Desktop
            },
            zIndex: 1, // Place above the background dim
          }}
        >
          Mission
        </Typography>

        {/* Mission Content */}
        <Typography
          sx={{
            position: "relative",
            display: "flex",
            fontFamily: "Poppins",
            color: "#585858",
            lineHeight: {
              xs: "28px", // Mobile
              sm: "32px", // Tablet
              md: "42px", // Desktop
            },
            fontWeight: "normal",
            textAlign: {
              xs: "center", // Center on mobile
              sm: "right", // Right-align on larger screens
            },
            fontSize: {
              xs: "16px", // Mobile
              sm: "18px", // Tablet
              md: "22px", // Desktop
              lg: "25px", // Large Desktop
            },
            padding: {
              xs: "2% 5%", // Mobile
              sm: "1% 10% 2% 20%", // Tablet
              md: "1% 10% 2% 40%", // Desktop
            },
            width: {
              xs: "90%", // Mobile
              sm: "70%", // Tablet
              md: "50%", // Desktop
            },
            margin: "0 auto", // Center content on mobile
            zIndex: 1, // Place above the background dim
          }}
        >
          Our mission is to enable businesses to harness the full potential of
          their data. We aim to deliver scalable, intelligent, and impactful
          solutions that solve real-world challenges and foster sustainable
          growth.
        </Typography>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          position: "relative",
          backgroundImage:
            'url("/assets/aboutus/visionpeople.png"), url("/assets/aboutus/citybuildings.png")',
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: {
            xs: "80% auto, cover", // Mobile
            sm: "60% auto, cover", // Tablet
            md: "50% auto, cover", // Desktop
          },
          backgroundPosition: {
            xs: "top center, center", // Centered on mobile
            sm: "right, center", // Right-aligned on tablet and desktop
          },
          backgroundColor: "#FFEBF8",
          padding: {
            xs: "5% 0 8% 0", // Mobile
            sm: "5% 0 10% 0", // Tablet
            md: "5% 0 13% 0", // Desktop
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: {
              xs: "rgba(255, 255, 255, 0.6)", // Dim background on mobile
              sm: "transparent", // No dimming on larger screens
            },
            zIndex: 0, // Behind content
          },
        }}
      >
        {/* Vision Title */}
        <Typography
          sx={{
            position: "relative",
            display: "flex",
            fontFamily: "Orbitron",
            fontSize: {
              xs: "36px", // Mobile
              sm: "48px", // Tablet
              md: "60px", // Desktop
              lg: "72px", // Large Desktop
            },
            fontWeight: "800",
            color: "#000",
            letterSpacing: "2px",
            justifyContent: {
              xs: "center", // Centered on mobile
              sm: "flex-start", // Left-aligned on tablet and desktop
            },
            padding: {
              xs: "4% 5% 0 5%", // Mobile
              sm: "6% 5% 0 10%", // Tablet and Desktop
            },
            zIndex: 1, // Above background dim
          }}
        >
          Vision
        </Typography>

        {/* Vision Content */}
        <Typography
          sx={{
            position: "relative",
            display: "flex",
            fontFamily: "Poppins",
            color: "#585858",
            lineHeight: {
              xs: "28px", // Mobile
              sm: "32px", // Tablet
              md: "42px", // Desktop
            },
            fontWeight: "normal",
            textAlign: {
              xs: "center", // Centered on mobile
              sm: "left", // Left-aligned on tablet and desktop
            },
            fontSize: {
              xs: "16px", // Mobile
              sm: "18px", // Tablet
              md: "22px", // Desktop
              lg: "25px", // Large Desktop
            },
            padding: {
              xs: "2% 5%", // Mobile
              sm: "1% 10% 2% 10%", // Tablet and Desktop
            },
            width: {
              xs: "90%", // Mobile
              sm: "70%", // Tablet
              md: "50%", // Desktop
            },
            zIndex: 1, // Above background dim
          }}
        >
          At Tecloq, we envision a world where innovation thrives on diversity,
          inclusion, and equality.
        </Typography>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          background:
            "linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 15%, #EDABE4 100%)",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            flex: 1,
            fontFamily: "Inter",
            fontSize: { xs: "24px", sm: "30px", md: "40px" }, // Responsive font size
            fontWeight: "800",
            color: "#000",
            justifyContent: "center",
            padding: { xs: "8%", md: "4%" }, // Responsive padding
            textAlign: "center", // Center text on smaller screens
          }}
        >
          Tailored Data Strategies.
          <br />
          Approach That Matters.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "column", md: "row" },
            flex: "1",
            height: "auto",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {/* <section sx={{ boxShadow: "none", width: {sm:"100%", md:"30%"} }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "800",
                fontSize: "20px",
                color: "#4D4D4D",
                textAlign: "right",
              }}
            >
              Evaluation
            </Typography>
            <ul
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                alignItems: "end",
                width: "100%",
                listStyle: "none",
                padding: "0",
              }}
            >
              <li
                style={{
                  width: "70%",
                  textAlign: "right",
                  marginBottom: "20px",
                }}
              >
                • Formulate business-driven Use Cases and MVPs
              </li>
              <li
                style={{
                  width: "70%",
                  textAlign: "right",
                  marginBottom: "20px",
                }}
              >
                • Create current data landscape assessment
              </li>
              <li
                style={{
                  width: "70%",
                  textAlign: "right",
                  marginBottom: "20px",
                }}
              >
                • Develop the future-looking proposed solution
              </li>
              <li
                style={{
                  width: "70%",
                  textAlign: "right",
                  marginBottom: "20px",
                }}
              >
                • Provide detailed implementation plan
              </li>
            </ul>
          </section> */}

          <Box
            sx={{
              boxShadow: "none",
              width: { xs: "100%", md: "30%" }, // Full width on small screens, 30% on larger screens
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "800",
                fontSize: "20px",
                color: "#4D4D4D",
                textAlign: { xs: "center", md: "right" }, // Center text on mobile, right-align on larger screens
              }}
            >
              Evaluation
            </Typography>
            <Box
              component="ul"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-end" }, // Center on mobile, right-align on larger screens
                width: "100%",
                listStyle: "none",
                padding: "0",
              }}
            >
              {[
                "Formulate business-driven Use Cases and MVPs",
                "Create current data landscape assessment",
                "Develop the future-looking proposed solution",
                "Provide detailed implementation plan",
              ].map((item, index) => (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    width: "70%",
                    textAlign: { xs: "center", md: "right" }, // Center text on mobile, right-align on larger screens
                    marginBottom: "20px",
                  }}
                >
                  • {item}
                </Box>
              ))}
            </Box>
          </Box>

          <section
            style={{
              position: "relative",
              width: "500px",
              height: "700px",
              // margin: "auto",
            }}
          >
            <div className="pc-view">
              <Typography
                style={{
                  display: "flex",
                  flex: "1",
                  fontFamily: "Inter",
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#000",
                  justifyContent: "center",
                  padding: "4%",
                  position: "absolute",
                  top: "20%",
                  left: "41%",
                }}
              >
                Data
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  flex: "1",
                  fontFamily: "Inter",
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#000",
                  justifyContent: "center",
                  padding: "4%",
                  position: "absolute",
                  top: "24%",
                  left: "37%",
                }}
              >
                Strategies
              </Typography>
              <img
                src="/assets/aboutus/evaluation.png"
                alt="Evaluation"
                className="bouncy-image"
                style={{
                  position: "absolute",
                  top: "-11px",
                  left: "8.2%",
                  width: "63%",
                  height: "auto",
                }}
              />
              <img
                src="/assets/aboutus/optimization.png"
                alt="Optimization"
                className="bouncy-image"
                style={{
                  position: "absolute",
                  top: "25.6%",
                  left: "11%",
                  width: "63%",
                  height: "auto",
                  transform: "rotate(1deg)",
                }}
              />
              <img
                src="/assets/aboutus/implementation.png"
                alt="Implementation"
                className="bouncy-image"
                style={{
                  position: "absolute",
                  top: "3.5%",
                  left: "54.3%",
                  width: "40%",
                  height: "auto",
                  transform: "rotate(0deg)",
                }}
              />
            </div>
            <div className="mobile-view">
              <img style={{width:"350px"}} src="/assets/aboutus/DataaStrategies.png"></img>
            </div>

            <style>
    {`
      /* Default: Show PC View */
      .pc-view {
        display: block;
      }

      .mobile-view {
        display: none;
      }

      section {
        height: 700px; /* Default height */
      }

      /* MOBILE VIEW */
      @media (max-width: 768px) {

        .pc-view {
          display: none;
        }
        .mobile-view {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 400px; /* Reduced height for mobile */
        }
        section {
          height: 300px !important; /* Adjust section height */
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    `}
  </style>
          </section>

          

          <Box
            sx={{
              boxShadow: "none",
              width: { xs: "100%", md: "30%" }, // Full width on mobile, 30% on PC
              margin: { xs: "auto", md: "0" }, // Center on mobile, left-align on PC
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "800",
                fontSize: "20px",
                color: "#4D4D4D",
                textAlign: { xs: "center", md: "left" }, // Center on mobile, left on PC
                marginBottom: "16px",
              }}
            >
              Implementation
            </Typography>
            <Box
              component="ul"
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" }, // Center on mobile, left on PC
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" },
                width: "100%",
                listStyle: "none",
                padding: 0,
              }}
            >
              {[
                "Cover all aspects of the data lifecycle and provide deep technical expertise",
                "Stay close to deliverables and focus on iterative value generation",
                "Provide thought leadership and move up the data maturity curve",
              ].map((item, index) => (
                <Box
                  key={index}
                  component="li"
                  sx={{
                    width: { xs: "90%", md: "70%" },
                    textAlign: { xs: "center", md: "left" }, // Center on mobile, left on PC
                    marginBottom: "20px",
                  }}
                >
                  • {item}
                </Box>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              boxShadow: "none",
              width: { xs: "100%", md: "30%" }, // Full width on mobile, 30% on PC
              position: { xs: "static", md: "absolute" }, // Absolute positioning only on PC
              bottom: { md: "0%" },
              right: { md: "33%" },
              margin: { xs: "auto", md: "0" }, // Center on mobile, aligned on PC
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "800",
                fontSize: "20px",
                color: "#4D4D4D",
                textAlign: { xs: "center", md: "left" }, // Center on mobile, left on PC
                marginBottom: "16px",
              }}
            >
              Optimization
            </Typography>
            <Box
              component="ul"
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" }, // Center on mobile, left on PC
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" },
                width: "100%",
                listStyle: "none",
                padding: 0,
              }}
            >
              {[
                "Do complete Health Check using various in-house solutions",
                "Discover areas of improvement and recommendations",
                "Create and prioritize the overall optimization plan",
                "Generate real value by saving costs, improving performance, and increasing adoption",
              ].map((item, index) => (
                <Box
                  key={index}
                  component="li"
                  sx={{
                    width: { xs: "90%", md: "70%" },
                    textAlign: { xs: "center", md: "left" }, // Center on mobile, left on PC
                    marginBottom: "20px",
                  }}
                >
                  • {item}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};
export default AboutUs;
